// src/components/ScrollManager.jsx
import { useLocation } from "react-router-dom";
import { useLayoutEffect } from "react";

export default function ScrollManager() {
  const location = useLocation();

  useLayoutEffect(() => {
    const html = document.documentElement;
    const prevBehavior = html.style.scrollBehavior;
    // prevent smooth animation on route change
    html.style.scrollBehavior = "auto";

    if (location.hash) {
      const id = decodeURIComponent(location.hash.slice(1));
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ block: "start" });
      } else {
        window.scrollTo(0, 0);
      }
    } else {
      window.scrollTo(0, 0);
    }

    // restore whatever you had (e.g. smooth) after the paint
    requestAnimationFrame(() => {
      html.style.scrollBehavior = prevBehavior || "";
    });
  }, [location.pathname, location.hash]);

  return null;
}
